import { useMutation } from '@tanstack/react-query';
import { apiClinicOnboardingRegisterUser } from 'lib/api/firebase/apis/apis';


export function useBusinessOnboardingUserRegistrationMutation() {
  return useMutation({
    mutationFn: apiClinicOnboardingRegisterUser,
  });
}
